import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { RedirectAs404 } from './Error404';
import Modal from './Modal';


/** This component provides URL-based modal rendering. the 'items' prop should
contain an object with url slugs as keys and modal content objects as values.
URL paths are relative to that of the parent component. */
class ModalRouter extends Component {
  constructor (props) {
    super(props);
    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  handleModalOpen (routeProps, modalContent) {
    const { onModalOpen } = this.props;
    onModalOpen(routeProps, modalContent);
  }

  handleModalClose () {
    const { history, match, onModalClose } = this.props;
    const baseUrl = this.props.baseUrl || match.url;
    history.push(baseUrl);
    onModalClose();
  }

  renderModalRoutes () {
    const { match, items, modalStyles, onClickOutsideModal } = this.props;
    const baseUrl = this.props.baseUrl || match.url;

    return (
      <Switch key="modal-routes">
        <Route exact path={baseUrl} />
        <Route exact path={`${baseUrl}/:slug`} render={props => {
          const { slug } = props.match.params;
          const matchedItem = items[slug];
          const afterOpenCallback = this.handleModalOpen.bind(this, props, matchedItem);
          return matchedItem ? (
            <Modal
              isOpen
              content={{ ...matchedItem }}
              onAfterOpen={afterOpenCallback}
              onRequestClose={this.handleModalClose}
              onClickOutside={onClickOutsideModal}
              style={modalStyles}
            />
          ) : <RedirectAs404 />;
        }} />
        <Route component={RedirectAs404} />
      </Switch>
    );
  }

  render () {
    return [this.props.children, this.renderModalRoutes()];
  }
}

ModalRouter.propTypes = {
  items: PropTypes.object,
  modalStyles: PropTypes.object,
  onModalOpen: PropTypes.func,
  onModalClose: PropTypes.func,
  onClickOutsideModal: PropTypes.func,
};

ModalRouter.defaultProps = {
  items: {},
  modalStyles: {
    overlay: {},
    content: {},
  },
  onModalOpen: () => {},
  onModalClose: () => {},
  onClickOutsideModal: () => {},
};

export default withRouter(ModalRouter);



// WEBPACK FOOTER //
// ./src/components/ModalRouter.js